(() => {
  'use strict';
  const initialize = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('.promise-track,.gifted-marquee-track').forEach(track => {
      if (track.classList.contains('promise-track')) {
        const group = track.firstElementChild;
        const messages = [...group.children];
        // Keep the rolling strip filled even on wide desktop displays.
        for (let copy = 0; copy < 8 && group.getBoundingClientRect().width < Math.max(root.clientWidth, 2560); copy++) {
          messages.forEach(message => {
            const repeat = message.cloneNode(true);
            repeat.setAttribute('aria-hidden', 'true');
            group.append(repeat);
          });
        }
        track.style.animationDuration = `${group.getBoundingClientRect().width / 38}s`;
      }
      const clone = track.firstElementChild.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('img').forEach(img => { img.alt = ''; });
      track.append(clone);
    });
    const nameInput = root.querySelector('[data-name-input]');
    const sticky = root.querySelector('.mobile-cta');
    if (sticky && 'IntersectionObserver' in window) {
      const visibleActions = new Set();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? visibleActions.add(entry.target) : visibleActions.delete(entry.target));
        sticky.hidden = visibleActions.size > 0;
      }, { threshold: 0.1 });
      root.querySelectorAll('.hero .primary-button,.final-cta .primary-button,.name-demo .primary-button').forEach(button => observer.observe(button));
    }
    nameInput?.addEventListener('input', () => {
      root.querySelector('[data-name-output]').textContent = nameInput.value.trim() || 'Their Name';
    });
    const products = [...root.querySelectorAll('.product-card')];
    const status = root.querySelector('[data-filter-status]');
    const clear = root.querySelector('[data-clear-filters]');
    const empty = root.querySelector('[data-empty-filter]');
    const dialog = root.querySelector('[data-video-dialog]');
    const videoFrame = root.querySelector('[data-video-frame]');
    const rail = root.querySelector('[data-social-rail]');
    const filters = { translation: '', size: '' };
    let opener;
    let viewed = false;
    const consent = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    const pendingEvents = [];
    const deliver = () => {
      if (!consent()) { pendingEvents.length = 0; return; }
      for (let index = pendingEvents.length - 1; index >= 0; index--) {
        const item = pendingEvents[index];
        if (!item.google && typeof window.gtag === 'function') {
          // Reuse the store's installed Google tag; never initialize another tag.
          window.gtag('event', item.event, { ...item.detail, send_to: 'G-5F78PVN5TT' });
          item.google = true;
        }
        if (!item.meta && window.Shopify.customerPrivacy.marketingAllowed?.() === true && typeof window.fbq === 'function') {
          // Custom interactions only: Shopify owns commerce and PageView events.
          window.fbq('trackCustom', item.event, item.detail);
          item.meta = true;
        }
        if (item.google && (item.meta || window.Shopify.customerPrivacy.marketingAllowed?.() !== true)) pendingEvents.splice(index, 1);
      }
    };
    const track = (event, detail = {}) => {
      if (!consent()) return;
      const parameters = { landing_page: 'personalized-bibles-under-25', currency: root.dataset.currency, ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...parameters });
      pendingEvents.push({ event, detail: parameters, google: false, meta: false });
      deliver();
    };
    const view = () => {
      if (!viewed && consent()) {
        viewed = true;
        track('landing_page_view', { eligible_product_count: products.length });
      }
    };
    view();
    window.addEventListener('load', deliver, { once: true });
    let deliveryAttempts = 0;
    const deliveryTimer = setInterval(() => {
      deliver();
      if (++deliveryAttempts >= 20) clearInterval(deliveryTimer);
    }, 500);
    document.addEventListener('visitorConsentCollected', view);
    if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) view(); });
    }
    const applyFilters = () => {
      let count = 0;
      for (const product of products) {
        const visible = (!filters.translation || product.dataset.translation === filters.translation)
          && (!filters.size || product.dataset.printSize === filters.size);
        product.hidden = !visible;
        if (visible) count++;
      }
      status.textContent = `${count} eligible Bibles${filters.translation ? ` · ${filters.translation}` : ''}${filters.size ? ` · ${filters.size} print` : ''}`;
      clear.hidden = !filters.translation && !filters.size;
      empty.hidden = count > 0;
      root.querySelectorAll('[data-translation-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.translationFilter === filters.translation)));
      root.querySelectorAll('[data-size-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.sizeFilter === filters.size)));
      root.querySelector('[data-product-grid]').scrollLeft = 0;
      root.querySelector('#affordable-products').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    root.addEventListener('click', (event) => {
      const target = event.target.closest('a,button');
      if (!target) return;
      if (target.hasAttribute('data-motion-toggle')) {
        const paused = root.dataset.motionPaused !== 'true';
        root.dataset.motionPaused = String(paused);
        target.setAttribute('aria-pressed', String(paused));
        target.setAttribute('aria-label', paused ? 'Resume scrolling strips' : 'Pause scrolling strips');
        target.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      }
      if (target.dataset.event) {
        const product = target.closest('[data-product-id]');
        track(target.dataset.event, {
          placement: target.closest('.hero') ? 'hero' : target.closest('.product-card') ? 'product_grid' : 'page',
          ...(product ? { product_id: product.dataset.productId, variant_id: product.dataset.variantId, value: Number(product.dataset.price || 0) / 100 } : {})
        });
      }
      if (target.hasAttribute('data-translation-filter')) {
        filters.translation = target.dataset.translationFilter;
        track('translation_click', { translation: filters.translation });
        applyFilters();
      }
      if (target.hasAttribute('data-size-filter')) {
        filters.size = target.dataset.sizeFilter;
        track('text_size_click', { text_size: filters.size });
        applyFilters();
      }
      if (target.hasAttribute('data-clear-filters')) {
        filters.translation = ''; filters.size = ''; applyFilters();
      }
      if (target.dataset.videoId && /^\d+$/.test(target.dataset.videoId)) {
        opener = target;
        const iframe = document.createElement('iframe');
        iframe.title = target.getAttribute('aria-label');
        iframe.src = `https://www.tiktok.com/player/v1/${target.dataset.videoId}?autoplay=1&loop=0&rel=0`;
        iframe.allow = 'autoplay; encrypted-media; fullscreen';
        iframe.allowFullscreen = true;
        videoFrame.replaceChildren(iframe);
        root.querySelector('[data-tiktok-link]').href = `https://www.tiktok.com/@${encodeURIComponent(target.dataset.videoAuthor)}/video/${target.dataset.videoId}`;
        dialog.showModal();
        track('tiktok_interaction', { action: 'open', video_id: target.dataset.videoId });
      }
      if (target.hasAttribute('data-close-video')) dialog.close();
      if (target.hasAttribute('data-social-direction')) {
        rail.scrollBy({ left: Number(target.dataset.socialDirection) * rail.clientWidth * 0.8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        track('tiktok_interaction', { action: 'carousel_arrow' });
      }
      if (target.hasAttribute('data-tiktok-link')) track('tiktok_interaction', { action: 'open_tiktok', video_id: opener?.dataset.videoId });
    });
    dialog.addEventListener('close', () => {
      videoFrame.replaceChildren();
      track('tiktok_interaction', { action: 'close', video_id: opener?.dataset.videoId });
      opener?.focus();
    });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    root.querySelectorAll('[data-faq-id]').forEach((faq) => faq.addEventListener('toggle', () => track('faq_interaction', { faq_id: faq.dataset.faqId, action: faq.open ? 'open' : 'close' })));
    rail.addEventListener('pointerup', () => track('tiktok_interaction', { action: 'carousel_interaction' }));
  };
  document.querySelectorAll('[data-affordable-page]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-affordable-page]')));
})();
